import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M3 12a9 9 0 1 0 18.001 0A9 9 0 0 0 3 12M10 16.5l2-3m0 0 2 3m-2-3v-2m0 0 3-1m-3 1-3-1"
    }, null, -1 /* CACHED */),
    _createElementVNode("path", {
      fill: "#333",
      stroke: "#333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1"
    }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }